import { render, staticRenderFns } from "./BaseSidebar.vue?vue&type=template&id=3eb0b1d0&scoped=true"
import script from "./BaseSidebar.vue?vue&type=script&lang=ts"
export * from "./BaseSidebar.vue?vue&type=script&lang=ts"
import style0 from "./BaseSidebar.vue?vue&type=style&index=0&id=3eb0b1d0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb0b1d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3eb0b1d0')) {
      api.createRecord('3eb0b1d0', component.options)
    } else {
      api.reload('3eb0b1d0', component.options)
    }
    module.hot.accept("./BaseSidebar.vue?vue&type=template&id=3eb0b1d0&scoped=true", function () {
      api.rerender('3eb0b1d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sidebar/BaseSidebar.vue"
export default component.exports